var map = {
	"./beauty.mp4": 49536,
	"./guide.dressform.mp4": 94438,
	"./guide.mp4": 57020,
	"./guide_clothing.mp4": 44026,
	"./guide_commodity.mp4": 42247,
	"./light.mp4": 64688,
	"./mainVideo.mp4": 91090,
	"./remove.mp4": 84389,
	"./shape.mp4": 19276,
	"./sr.mp4": 96146,
	"./transform.mp4": 5817
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62403;